/* eslint-disable max-len */
import _ from 'lodash';
import {
  SET_LAYER_VISIBILITY,
  SET_GROUP_VISIBILITY,
  SET_CURRENT_MAP_COMPOSITION,
  SET_CURRENT_MINIMAP_COMPOSITION,
  SET_LAYERS_AREA,
} from '../constants';

const layersInitialState = {
  currentMapComposition: null,
  currentMiniMapComposition: null,
  layersIndex: null,
};

const setMapLayerVisibility = (state, action) => ({
  ...state,
  currentMapComposition: {
    ...state.currentMapComposition,
    layers: _.filter(state.currentMapComposition.layers, o => {
      if (action.payload.warstwa === o.warstwa) {
        o.isVisible = !o.isVisible;
        return o;
      }
      return o;
    }),
  },
});
const setMapGroupVisibility = (state, action) => {
  return {
    ...state,
    currentMapComposition: {
      ...state.currentMapComposition,
      groups: _.filter(state.currentMapComposition.groups, o => {
        if (action.payload.nazwa === o.nazwa) {
          o.isVisible = !action.payload.isVisible;
          return o;
        }
        return o;
      }),
      layers: _.filter(state.currentMapComposition.layers, o => {
        if (action.payload.nazwa === o.grupa) {
          o.isVisible = action.payload.isVisible;
          return o;
        }
        return o;
      }),
    },
  };
};

const setComposition = (mapObject, state, action) => {
  const odp = action.payload;
  // Domyślnie włączone warstwy
  const disabled = [ 
    'inwestor',
    'max_wysokosc_lin',
    'nieprzekraczalne_linie',
    'granica_gminy',
    'dzialki_ewidencyjne2',
    'tereny_sasiadujace',
    '7.117.27.23',
    '7.117.27.24',
    '7.117.27.25',
    '7.116.27.03',
    '7.116.27.04',
    '7.116.27.05',
    'cmentarze',
    'cmentarze_sektory',
    'cmentarze_infrastruktura_powierzchniowa',
    'cmentarze_infrastruktura_liniowa',
    'cmentarze_infrastruktura_punktowa',
    'cmentarze_groby',
    'Zdjęcie cmentarza - Wierzbna',
    'Zdjęcie cmentarza - Armii Krajowej',
    'Zdjęcie cmentarza - Olszowa',
    'Zdjęcie cmentarza - Świdnicka',
    'Zdjęcie cmentarza - Wałbrzyska',
    'Zdjęcie cmentarza - Browarowa',
    'Zdjęcie cmentarza - Kamiennogórska',
    'Zdjęcie cmentarza - Świerzawa',
    'Zdjęcia cmentarza - Nowy kościół',
    'Zdjęcie cmentarza - Rząśnik',
    'Zdjęcie cmentarza — Siekierczyn',
    'Zdjęcie cmentarza — Rudzica',
    'Zdjęcie cmentarza — Zaręba',
    'etykiety'
  ];
  odp.layers = _.filter(odp.layers, o => {
    if (disabled.indexOf(o.warstwa) > -1) {
      o.isVisible = true;
    } else {
      o.isVisible = false;
    }
    return o;
  });
  odp.groups = _.filter(odp.groups, o => {
    o.isVisible = true;
    return o;
  });
  if (mapObject === 'map') {
    return {
      ...state,
      currentMapComposition: odp,
    };
  }
  return {
    ...state,
    currentMiniMapComposition: odp,
  };
};

const setLayersArea = (state, action) => ({
  ...state,
  layersIndex: action.payload,
});

const setCurrentMapComposition = (state, action) => setComposition('map', state, action);

const setCurrentMinimapComposition = (state, action) => setComposition('minimap', state, action);

export default function reducer(state = layersInitialState, action) {
  return ({
    [SET_LAYER_VISIBILITY]: setMapLayerVisibility,
    [SET_GROUP_VISIBILITY]: setMapGroupVisibility,
    [SET_CURRENT_MAP_COMPOSITION]: setCurrentMapComposition,
    [SET_CURRENT_MINIMAP_COMPOSITION]: setCurrentMinimapComposition,
    [SET_LAYERS_AREA]: setLayersArea,
  }[action.type] || (s => s))(state, action);
}



// WEBPACK FOOTER //
// src/reducers/layers.js